export const isStandalone = process.env.NODE_ENV === 'development' && window.parent === window.self;

export const isEditorX =
  location.hostname.indexOf('editorx.com') !== -1 || (window.commonConfig && window.commonConfig.brand === 'editorx');
export const wixOrEditorxDomain = isEditorX ? 'manage.editorx.com' : 'manage.wix.com';
